import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

// Kiterjesztjük a TooltipProps-t a className prop-pal
interface CustomTooltipProps extends TooltipProps {
  className?: string;
}

// Külön komponens, amiben destructuráljuk a className-t és továbbadjuk a Tooltip-nek
const TooltipComponent: React.FC<CustomTooltipProps> = ({
  className,
  ...props
}) => <Tooltip {...props} classes={{ popper: className }} />;

// A styled hívás most már tisztán kapja ezt a komponenst
export const CustomTooltip = styled(TooltipComponent)(({ theme }) => ({
  // override a tooltip stílusát
  [`& .${theme.components?.MuiTooltip?.styleOverrides?.tooltip || "MuiTooltip-tooltip"}`]:
    {
      backgroundColor: theme.palette.darkBase.main,
      maxWidth: "400px",
      height: "auto",
      fontSize: "16px",
    },
  // override az arrow színét
  [`& .${theme.components?.MuiTooltip?.styleOverrides?.arrow || "MuiTooltip-arrow"}`]:
    {
      color: theme.palette.darkBase.main,
    },
}));
